import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AddressPoint } from '../../models/load-store';
import { NewPointCedi } from 'src/app/components/massive/pages/create/components/parametrizacion/parametrizacion.interface';

@Component({
  selector: 'app-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.sass'],
})
export class AddressCardComponent implements OnInit {
  public address = '';
  public showDeleteAddress = false;
  public deleteAddressId: number;
  public showUpdateAddress = false;
  public addressPointCard: AddressPoint;
  @Input() addresspoint: NewPointCedi;
  @Output() deletepoint = new EventEmitter();
  @Output() updatepoint = new EventEmitter();
  @Input() typeaddress: boolean;

  constructor() {
    this.addresspoint = {
      id: 0,
      address: '',
      name: '',
      lat: 0,
      lng: 0,
      idCity: 0,
      city: '',
      istDistributionCenter: false,
    };
  }

  ngOnInit(): void {
    /** */
  }

  deletePointAddress(idNumber: number): void {
    this.showDeleteAddress = true;
    this.deleteAddressId = idNumber;
  }

  validateDeleteAddress(confirm: boolean): void {
    if (confirm) {
      this.deletepoint.emit(this.deleteAddressId);
      this.showDeleteAddress = false;
    } else {
      this.showDeleteAddress = false;
    }
  }

  updateAddressPoint(addressId: string): void {
    this.updatepoint.emit(addressId);
  }
}
